import * as cookie from 'cookie'
import { PlatformConfig, PlatformConfigSchema } from '../schemas'
import { validateOpCo, validateOpCoLocale, validateOpCoMarket } from './validation'

export const AVIOS_PLATFORM_COOKIES = {
  AVIOS_OP_CO: 'AVIOS_OPCO',
  AVIOS_LOCALE: 'AVIOS_OPCO_LANG',
  AVIOS_MARKET: 'AVIOS_OPCO_MARKET',
}

export const getPlatformConfigFromCookies = (
  cookies: Record<string, string | undefined> | string
): PlatformConfig => {
  const parsedCookies = typeof cookies === 'string' ? cookie.parse(cookies) : cookies
  const maybeOpCoCookie = parsedCookies[AVIOS_PLATFORM_COOKIES.AVIOS_OP_CO]
  const maybeLocaleCookie = parsedCookies[AVIOS_PLATFORM_COOKIES.AVIOS_LOCALE]
  const maybeMarketCookie = parsedCookies[AVIOS_PLATFORM_COOKIES.AVIOS_MARKET]

  const opCo = validateOpCo(maybeOpCoCookie)
  const locale = validateOpCoLocale(opCo, maybeLocaleCookie)
  const market = validateOpCoMarket(opCo, maybeMarketCookie)

  return PlatformConfigSchema.parse({ opCo, locale, market, theme: 'avios' })
}
